import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import LeadSection from '../../site-render/src/LeadSection';

const createLead = gql`
  mutation createLead($input: LeadInput!) {
    createLead(input: $input) {
      id
    }
  }
`;

class LeadSectionContainer extends Component {
  static propTypes = {
    mutate: PropTypes.func.isRequired,
    eventId: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  };

  state = {
    loading: false,
    success: false,
  };

  onSubmit = async values => {
    const {
      mutate,
      site: { eventId },
      language,
    } = this.props;
    try {
      this.setState({ loading: true });
      await mutate({
        variables: {
          input: {
            source: 'leadSection',
            eventId,
            language,
            ...values,
          },
        },
      });
      this.setState({ loading: false, success: true });
    } catch (e) {
      // TODO: handle error
      this.setState({ loading: false });
      console.error(e);
    }
  };

  render() {
    const { loading, success } = this.state;
    return (
      <LeadSection {...this.props} loading={loading} success={success} onSubmit={this.onSubmit} />
    );
  }
}

export default graphql(createLead)(LeadSectionContainer);



// WEBPACK FOOTER //
// ./src/containers/LeadSectionContainer/LeadSectionContainer.js